import { webfontBaseUrl } from 'elements/icon/font-awesome/v6.5.1/webfont-base-url.js'
import { css, CSSResult } from 'lit'


/*!
 * Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2023 Fonticons, Inc.
 */
export const faBrandsFont: CSSResult = css`
  :root, :host {
    --fa-style-family-brands: 'Font Awesome 6 Brands';
    --fa-font-brands: normal 400 1em/1 'Font Awesome 6 Brands';
  }

  @font-face {
    font-family: 'Font Awesome 6 Brands';
    font-style: normal;
    font-weight: 400;
    font-display: block;
    src: url("${webfontBaseUrl}/fa-brands-400.woff2") format("woff2"), url("${webfontBaseUrl}/fa-brands-400.ttf") format("truetype");
  }`

// Split to allow the @font-face to be loaded at the document level,
// while the class styles are loaded at the element level.
export const faBrandsClass: CSSResult = css`
  .fab,
  .fa-brands {
    font-weight: 400;
  }`
